export default __webpack_public_path__ + "static/media/CRDoubleToro.f5306f89.png";